import React, { useEffect } from 'react';
import HorizontalSplitIcon from '@mui/icons-material/HorizontalSplit';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Form from 'react-bootstrap/Form';
import Avatar from '../css/Avatar1.png'
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { matchPath, useLocation } from 'react-router-dom';

const ROUTE_ARR = {
  "/bidder-management": ["bidderManagement", "bidderHistory", "orderHistory"],
  "/seller-management": ["sellerManagement", "sellerRequest", "rejectRequest", "orderHistorySeller", "liveProduct"],
  "/category-management": [],
  "/sub-category": [],
  "/product-management": [],
  "/dashboard": [],
  "/order-management": ["orderManagement"],
}
export default function Header() {
  const location = useLocation();
  // console.log(ROUTE_ARR)
  const name = localStorage.getItem("auction_userName")
  const toggleSidebar = () => {
    document.body.classList.toggle("toggle_sidebar");
  }
  useEffect(() => {
    Object.entries(ROUTE_ARR).forEach(([key, val]) => {
      const match = matchPath({
        path: `${key}/*`,
        exact: false,
        strict: false
      }, location.pathname);

      // if match then remove all previous keys
      // console.log(match)
      if (match) {
        try {
          let tempVar = {};
          let localData = JSON.parse(localStorage.getItem("adminSearch"))
          val.forEach((item) => {
            tempVar = { ...tempVar, [item]: localData[item] }
          })
          localStorage.setItem("adminSearch", JSON.stringify(tempVar))
        }
        catch (err) {
          // localStorage.removeItem("admin")
        }
      }
    })
  }, [location])

  return (
    <div className="mainHead">

      <div className='header'>
<div></div>
        <div className='mx-2'>
          <img style={{ height: "40px", width: "40px" }} src={Avatar} alt="profile" />
          {/* <span className='mx-2 fs-6'>{name}</span> comes from Api Name */}
          <span className='mx-2 fs-6'>Admin</span>
        </div>
        {/* <Link>
          <figure>
            <img alt="" src="./images/user.png" />
          </figure>
          {empName}
        </Link> */}
        {/* <div className="logo"><FaBars /></div> */}
        {/* <div className="header_notification"> <NotificationsIcon />
        <span className='bell'> 2</span> 

    <Form.Select aria-label="Default select example">
      <option> English</option>
      <option value="1">One</option>
      <option value="2">Two</option>
      <option value="3">Three</option>
    </Form.Select>


</div> */}
      </div>
    </div>
  )
}
